import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Lottie from "lottie-react";
import BangerPreloader from "assets/json/banger_game_preloader.json";
import GloryPreloader from "assets/json/glory_game_preloader.json";
import { useGetJWTSportsBookData } from "queries/useGetJWTSportsBook";
import { usePostMessageGR8 } from "hooks/usePostMessageGR8";
import * as authSelectors from "redux/auth/selectors";
import "./styles.sass";
import { useSelector } from "react-redux";
import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { Languages } from "types/localization";

export const SportsBookGamePage = () => {
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const { data, isLoading, refetch } = useGetJWTSportsBookData();
  const { event, id } = useParams();
  const preloader =
    VITE_APP_PROJECT_NAME === "banger" ? BangerPreloader : GloryPreloader;
  const userLanguage = localStorage.getItem(STORAGE_LANGUAGE_NAME) || "EN";

  const urlForIFrame =
    isAuthenticated && data?.token
      ? `https://sport-iframe.pjdoi.xyz/${Languages[userLanguage]}/${event}/${id}/?jwt=${encodeURIComponent(data.token)}`
      : `https://sport-iframe.pjdoi.xyz/${Languages[userLanguage]}`;

  usePostMessageGR8();

  useEffect(() => {
    if (isAuthenticated) {
      refetch();
    }
    const iFrame = document.querySelector("iframe");
    if (iFrame && iFrame.contentWindow) {
      iFrame.contentWindow.postMessage(
        {
          type: "iframe-navigation",
          value: { path: `/${event}/${id}` },
        },
        "*",
      );
    }

    return () => {
      if (iFrame && iFrame.contentWindow) {
        iFrame.contentWindow.postMessage(
          {
            type: "iframe",
            value: { logout: true },
          },
          "*",
        );
      }
    };
  }, [isAuthenticated, refetch, event, id]);

  return (
    <div className="SportsBookPage">
      <div className="SportsBookPage__content">
        {isLoading ? (
          <div className="SportsBookPage__loader">
            <Lottie animationData={preloader} loop={false} />
          </div>
        ) : (
          <iframe
            src={urlForIFrame}
            allowFullScreen
            title="Sports Book"
            className="SportsBookPage__content_game"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          />
        )}
      </div>
    </div>
  );
};
